import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Components
import GridSkeleton from "../../../layout/standardgrid/types/GridSkeleton";
import StandardGridRecipe from "../../../layout/standardgrid/types/StandardGridRecipe";
import StandardGridMedia from "../../../layout/standardgrid/types/StandardGridMedia";
import StandardGridText from "../../../layout/standardgrid/types/StandardGridText";

// Actions
import { getPostData } from "../../../../actions/feed";

// Selectors
import { getPostDataFromCache } from "../../../../selectors/postSelectors";

const ForYouGridManager = ({ post, feed, getPostData }) => {
  const requestedRef = useRef(false);

  const postId = post.postid;
  const repostUserId = post.repostuser || null;
  const cachedData = getPostDataFromCache(feed, postId, repostUserId);
  const errorCooldownTs = feed?.postCache?.errors?.[postId];
  const inCooldown = errorCooldownTs && errorCooldownTs > Date.now();

  useEffect(() => {
    requestedRef.current = false;
  }, [postId, repostUserId]);

  useEffect(() => {
    if (!cachedData && !inCooldown && !requestedRef.current) {
      requestedRef.current = true;
      getPostData(postId, -1, repostUserId);
    }
  }, [cachedData, inCooldown, getPostData, postId, repostUserId]);

  const shouldShowSkeleton = !cachedData && !inCooldown;
  const hasError = !cachedData && inCooldown;

  if (hasError) return null; // prune tile entirely to avoid grid gaps

  return shouldShowSkeleton ? (
    <GridSkeleton />
  ) : cachedData ? (
    <>
      {cachedData.type === "recipe" && (
        <StandardGridRecipe recipeid={cachedData && cachedData.recipe && cachedData.recipe.id} />
      )}
      {cachedData.type === "media" && <StandardGridMedia post={cachedData} />}
      {cachedData.type === "text" && <StandardGridText post={cachedData} />}
    </>
  ) : null;
};

ForYouGridManager.propTypes = {
  post: PropTypes.object.isRequired,
  feed: PropTypes.object.isRequired,
  getPostData: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  feed: state.feed,
});

export default connect(mapStateToProps, { getPostData })(ForYouGridManager);
